// extracted by mini-css-extract-plugin
export default {"buttonStyle":"ButtonAdmin_buttonStyle__o-ULb"};